define("powergen/models/keyboard-key",
  [],
  function() {
    "use strict";
    var KeyboardKey;

    KeyboardKey = DS.Model.extend({
      alt: DS.attr('boolean')
    });


    return KeyboardKey;
  });